import { useContext, useEffect, useMemo, useState } from "react";
import AddPaymentWidget from "./../../components/AddPaymentWidget";

import OrdersListWidget from "../../components/AddPaymentWidget/OrdersListWidget";
import {
    useCrateOrderInvoice,
    useOrderInvoiceData,
} from "../../shared/hooks/useInvoicesData";

import _ from "lodash";
import { pdfjs } from "react-pdf";
import { AppContext } from "../../AppContext";
import { useAddons } from "../../shared/hooks/useItemsData";
import {
    useDefferOrderItem,
    useDivideOrderItemsData,
    useOrderItemOnHouse,
} from "../../shared/hooks/useTableOrderItemsData";
import { PosContext } from "../../shared/PosContext";
import { isJsonString } from "../../utils/floorUtils";
import InvoiceDetails from "./InvoiceDetails";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function WidgetsPage({
    mode,
    handleNext,
    backCallback,
    table,
    order,
    handleInvoiceClosed,
}) {
    const { setLoadingTable, selectedFloor } = useContext(AppContext);

    const { refetchTablesData } = useContext(PosContext);
    const { data: addons } = useAddons();

    const [discount, setDiscount] = useState(0);
    const [tip, setTip] = useState(0);
    const [entryItems, setEntryItems] = useState([]);
    const [invoice, setInvoice] = useState(null);
    const [invoiceName, setInvoiceName] = useState(null);
    const [isPaymentLoading, setPaymentLoading] = useState(false);

    const [finalPayload, setFinalPayload] = useState();
    const [amountAfterDiscount, setAmountAfterDiscount] = useState("00.00");

    const [paymentType, setPaymentType] = useState(null);

    const [presetDiscount, setPresetDiscount] = useState(null);
    const [orderOnHouse, setOrderOnHouse] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(false);

    const { data: model, isLoading: isInvoiceLoading } = useOrderInvoiceData(
        order ? order.name : Object.values(table.orders)[0].name
    );

    const roundToNearest5WithMaxCap = (num) => {
        if (num > 20) {
            return 20;
        }
        return Math.round(num / 5) * 5;
    };

    const [paymentData, setPaymentData] = useState({});

    useEffect(() => {
        if (order) {
            if (order.discount) {
                const totalBeforeDiscount = order.discount + order.amount;
                const _discount = roundToNearest5WithMaxCap(
                    (1 - order.amount / totalBeforeDiscount) * 100
                );
                setPresetDiscount(_discount);
                setDiscount(_discount);
                setPaymentData({
                    discount: _discount,
                    tip: 0,
                    amount: totalBeforeDiscount,
                    amountAfterDiscount: order.amount,
                    mode_of_payment: paymentType,
                    orderAmount: order.amount,
                    entryItems: [],
                });
            } else {
                setPresetDiscount(null);
                setPaymentData({
                    discount: 0,
                    tip: 0,
                    amount: order.amount,
                    amountAfterDiscount: order.amount,
                    mode_of_payment: paymentType,
                    orderAmount: order.amount,
                    entryItems: [],
                });
            }
        }
    }, [order]);

    const callHandleNext = (totalPayload) => {
        let objects = Object.entries(totalPayload.items);
        if (!objects || objects.length === 0) {
            const { doc, desk_form } = model;
            const { entry_items } = doc;
            const cash = model.amount;
            paymentData.amount = "" + Number(doc.amount);
            paymentData.orderAmount = "" + Number(doc.amount);
            setAmountAfterDiscount("" + Number(doc.amount));
        } else {
            let totalPayment = 0;

            Object.values(totalPayload.items).map((itemEntry) => {
                let addonsTotal = 0;
                const item = entryItems.find((i) => i.name === itemEntry.name);
                const itemAddons = item.addons
                    ? isJsonString(item.addons)
                        ? JSON.parse(item.addons)
                        : item.addons
                    : [];

                const _addons = addons.filter((i) =>
                    itemAddons.includes(i.item_code)
                );

                if (_addons.length > 0) {
                    _addons.forEach((addon) => {
                        addonsTotal += Number(addon.standard_rate);
                    });
                }
                totalPayment += item.rate * itemEntry.qty;
                totalPayment += addonsTotal;
            });

            paymentData.amount = "" + Number(totalPayment);
            paymentData.orderAmount = "" + Number(totalPayment);
            setAmountAfterDiscount("" + Number(totalPayment));

            setFinalPayload(totalPayload);
        }

        handleNext(finalPayload);
    };

    useEffect(() => {
        const { amount } = paymentData;
        const newAmount = amount - amount * (discount / 100);
        setAmountAfterDiscount("" + newAmount);
    }, [discount]);

    const handlePropertyChange = (event, propertyName, newValue) => {
        if (!newValue) newValue = event.target.value;
        setPaymentData((prevData) => ({
            ...prevData,
            [propertyName]: newValue,
        }));
    };

    const { mutate: createInvoiceMutation, isLoading: isCreatingInvoice } =
        useCrateOrderInvoice();
    const divideOrderItemsDataMutation = useDivideOrderItemsData();
    const onHouseOrderItemMutation = useOrderItemOnHouse();
    const defferedOrderItemMutation = useDefferOrderItem();

    useMemo(() => {
        if (model) {
            const { doc, desk_form } = model;
            setInvoice(doc);
            const { entry_items } = doc;
            const cash = model.amount;

            const filteredEntryItems = _.differenceWith(
                entry_items,
                addons,
                (entryItem, tempItem) => {
                    return (
                        _.toLower(entryItem.item_code) ===
                        _.toLower(tempItem.item_code)
                    );
                }
            );

            setEntryItems(filteredEntryItems);
        }
    }, [model]);

    // CREATE INVOICE
    const handleInvoice = (orderId, payload) => {
        let floor = selectedFloor?.name; //TODO NEEDS TESTING CHANGE TO PosContext
        let floorName = "";
        if (floor) {
            floorName = floor.name;
        }
        createInvoiceMutation(
            {
                orderId: orderId,
                formData: payload,
                floorName: floorName,
            },
            {
                onSuccess: (data, variables, context) => {
                    refetchTablesData();
                    // refetchFloorData();
                    const { invoice_name, status } = data.data.message;
                    if (invoice_name) {
                        if (handleInvoiceClosed) handleInvoiceClosed();
                        // setInvoiceName(invoice_name);
                    }
                },
                onError: (_err, _newTodo, context) => {
                    // Handle the error here
                    console.error("Error creating order invoice:", _err);
                    const { _server_messages } = _err;
                    if (_server_messages) {
                    }
                },
            }
        );
    };

    const putOrderOnHouse = () => {
        const orderId = model.doc.name;
        onHouseOrderItemMutation.mutate(
            {
                orderId: orderId,
            },
            {
                onSuccess: (data) => {
                    refetchTablesData();
                    setPaymentLoading(false);
                    if (handleInvoiceClosed) handleInvoiceClosed();
                },
                onError: (err) => {
                    console.log(err);
                },
            }
        );
    };

    const putOrderOnCustomer = () => {
        const orderId = model.doc.name;
        defferedOrderItemMutation.mutate(
            {
                orderId: orderId,
                customer: selectedCustomer,
                discount_percentage: discount,
            },
            {
                onSuccess: (data) => {
                    refetchTablesData();
                    setPaymentLoading(false);
                    if (handleInvoiceClosed) handleInvoiceClosed();
                },
                onError: (err) => {
                    console.log(err);
                },
            }
        );
    };

    const paymentConfirmed = () => {
        setPaymentLoading(true);

        if (orderOnHouse) {
            putOrderOnHouse();
            return;
        }

        if (selectedCustomer) {
            putOrderOnCustomer();
            return;
        }

        const orgOrderAmount = Number(paymentData?.orderAmount || 0);
        const discountAmount =
            orgOrderAmount - Number(amountAfterDiscount || 0);

        let cashItem = { Cash: Number(paymentData.amount) };

        if (paymentType === "Credit Card") {
            cashItem = { "Credit Card": Number(paymentData.amount) };
        }

        if (!model || !model.doc) return;

        const customer = model.doc.customer;
        const orderId = model.doc.name;
        const dinners = 1; //model.doc.dinners ?? 1;

        // const payload = { "mode_of_payment": cashItem, "customer": customer, "dinners": dinners , "discount_amount" : discountAmount,
        //     "apply_discount_on": "Grand Total"}

        const payload = {
            mode_of_payment: cashItem,
            customer: customer,
            dinners: dinners,
            discount_percentage: discount,
        };

        if (finalPayload) {
            divideOrderItemsDataMutation.mutate(
                {
                    orderId: orderId,
                    divisionPayload: finalPayload,
                },
                {
                    onSuccess: (data) => {
                        refetchTablesData();
                        setPaymentLoading(false);
                        const { message } = data;
                        const {
                            name,
                            entry_items: orderElements,
                            room,
                            room_description,
                            table_description,
                            table,
                            status,
                            customer,
                        } = message;

                        if (orderElements && orderElements.length > 0 && name) {
                            let invoiceTotalAmount = 0;
                            orderElements.forEach((entry_item) => {
                                invoiceTotalAmount +=
                                    entry_item.qty * entry_item.rate;
                            });

                            let cashItem = {
                                Cash: Number(invoiceTotalAmount),
                            };

                            if (paymentType === "Credit Card") {
                                cashItem = {
                                    "Credit Card": Number(invoiceTotalAmount),
                                };
                            }

                            const invoicePayload = {
                                mode_of_payment: cashItem,
                                customer: customer,
                                dinners: 1,
                                discount_percentage: discount,
                            };
                            handleInvoice(name, invoicePayload);
                        }
                    },
                }
            );
        } else {
            setPaymentLoading(false);
            handleInvoice(orderId, payload);
        }
    };

    const handleBackCallback = () => {
        setLoadingTable("");
        backCallback?.();
        // if (handleInvoiceClosed) handleInvoiceClosed();
    };

    return (
        <>
            {mode ? (
                <AddPaymentWidget
                    selectedTip={tip}
                    onUpdateTip={(e) => setTip(e)}
                    onUpdateDiscount={(e) => setDiscount(e)}
                    presetDiscount={presetDiscount}
                    selectedDiscount={discount}
                    onConfirm={paymentConfirmed}
                    isLoading={isPaymentLoading}
                    handleNext={handleNext}
                    inAmount={paymentData.amount}
                    orderAmount={paymentData.orderAmount}
                    amountAfterDiscount={amountAfterDiscount}
                    isCreatingInvoice={isCreatingInvoice}
                    handlePropertyChange={handlePropertyChange}
                    backCallback={handleBackCallback}
                    paymentType={paymentType}
                    setPaymentType={setPaymentType}
                    orderOnHouse={orderOnHouse}
                    setOrderOnHouse={setOrderOnHouse}
                    setSelectedCustomer={setSelectedCustomer}
                    selectedCustomer={selectedCustomer}
                />
            ) : (
                <OrdersListWidget
                    entryItems={entryItems}
                    handleNext={callHandleNext}
                    backCallback={handleBackCallback}
                    isInvoiceLoading={isInvoiceLoading}
                    table={table}
                />
            )}

            <InvoiceDetails
                onClose={handleBackCallback}
                invoiceName={invoiceName}
            ></InvoiceDetails>
        </>
    );
}
